import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const EntityCtx = createContext(null);

export const GROUP_VALUE = "__group__";

export function EntityProvider({ children }) {
    const { token } = useAuth();
    const [entities, setEntities] = useState([]);
    const [selectedEntityId, setSelectedEntityId] = useState(() => {
        return localStorage.getItem("acc_selected_entity") || GROUP_VALUE;
    });

    useEffect(() => {
        if (!token) {
            setEntities([]);
            return;
        }
        (async () => {
            try {
                const { data } = await api.get("/entities");
                setEntities(data);
            } catch {
                setEntities([]);
            }
        })();
    }, [token]);

    const selectEntity = (val) => {
        setSelectedEntityId(val);
        localStorage.setItem("acc_selected_entity", val);
    };

    const refreshEntities = async () => {
        const { data } = await api.get("/entities");
        setEntities(data);
    };

    const selectedEntity =
        selectedEntityId === GROUP_VALUE
            ? null
            : entities.find((e) => e.id === selectedEntityId);

    return (
        <EntityCtx.Provider
            value={{
                entities,
                selectedEntityId,
                selectedEntity,
                selectEntity,
                refreshEntities,
                isGroup: selectedEntityId === GROUP_VALUE,
            }}
        >
            {children}
        </EntityCtx.Provider>
    );
}

export const useEntity = () => useContext(EntityCtx);
